import { render, staticRenderFns } from "./productTransport_outside.vue?vue&type=template&id=d4083730&scoped=true"
import script from "./productTransport_outside.vue?vue&type=script&lang=js"
export * from "./productTransport_outside.vue?vue&type=script&lang=js"
import style0 from "./productTransport_outside.vue?vue&type=style&index=0&id=d4083730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4083730",
  null
  
)

export default component.exports